<template>
  <div :class="wrapClass">
    <div :class="labelClass">
      <div
        v-if="title"
        class="row"
      >
        <div class="col-12">
          <label :class="labelTitleClass">
            {{ title }}
            <required-badge v-show="required" />
          </label>
        </div>
      </div>
      <label
        v-if="description"
        :class="labelDescriptionClass"
        v-html="description"
      />
      <label
        v-for="(description, index) in descriptions"
        :key="index"
        :class="labelDescriptionClass"
        v-html="description"
      />
    </div>
    <error-message :errors="errors" />
    <!-- v-html="description" は変数内でhtmlタグを利用しているので、v-htmlを利用 -->
    <div
      class="w-100"
      :class="{ 'field_with_errors': errors.length > 0 }"
    >
      <input
        v-model="defaultText"
        :type="inputType"
        :name="postName"
        class="form-control"
        :class="{
          'disabled': disabled,
          'text-danger': overInputFlg,
          inputClass
        }"
        :rows="Math.ceil(maxLength / 100)"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        @keydown="setRemainingLength"
        @keyup="setRemainingLength"
        @keydown.enter="skipEnter"
      >
      <remaining-length
        v-if="!disabled && showRemainingLength"
        :remaining-length="remainingLength"
      />
    </div>
  </div>
</template>

<script>
import ErrorMessage from "./ErrorMessage.vue";
import RequiredBadge from "./RequiredBadge.vue";
import RemainingLength from "./RemainingLength.vue";

export default {
  components: {
    ErrorMessage,
    RequiredBadge,
    RemainingLength
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    descriptions: {
      type: Array,
      default() {
        return [];
      }
    },
    maxLength: {
      type: Number,
      default: 100
    },
    postName: {
      type: String,
      default: "survey_text"
    },
    required: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      default: "mb-3"
    },
    labelTitleClass: {
      type: String,
      default: ""
    },
    labelDescriptionClass: {
      type: String,
      default: "mt-description font-small text-dark-gray description"
    },
    errors: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showRemainingLength: {
      type: Boolean,
      default: true
    },
    wrapClass: {
      type: String,
      default: "mb-6"
    },
    placeholder: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    inputClass: {
      type: String,
      default: ""
    },
    inputType: {
      type: String,
      default: "text"
    },
    isSkipEnter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      remainingLength: this.maxLength,
      defaultText: "",
      overInputFlg: false
    };
  },
  watch: {
    defaultText() {
      this.$emit("change", this.defaultText);
    }
  },
  mounted() {
    this.defaultText = this.text;
    if (typeof this.text !== "undefined") {
      this.remainingLength = this.maxLength - this.text.length;
    }
    if (this.remainingLength < 0) {
      this.overInputFlg = true;
    }
    this.$emit("mount", this.defaultText);
  },
  methods: {
    setRemainingLength(e) {
      this.remainingLength = this.maxLength - e.target.value.length;
      if (this.remainingLength < 0) {
        this.overInputFlg = true;
      } else {
        this.overInputFlg = false;
      }
    },
    skipEnter(e) {
      if (this.isSkipEnter) {
        e.preventDefault();
      }
    }
  }
};
</script>

<style scoped>
.description {
  display: block;
}
.disabled {
  background-color: inherit;
  border: none;
}
</style>
